module.exports = __webpack_public_path__ + "static/media/esmia_logo.faad0796.png";